import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61cb33c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topic-card-breakdown-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-breakdown-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Responses Breakdown")
], -1))
const _hoisted_3 = { class: "topic-card-all-responses" }
const _hoisted_4 = { class: "topic-card-breakdown" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle positive" }, "⬤", -1))
const _hoisted_6 = { class: "topic-card-breakdown-count-container" }
const _hoisted_7 = { class: "topic-card-breakdown-count" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle neutral" }, "⬤", -1))
const _hoisted_9 = { class: "topic-card-breakdown-count-container" }
const _hoisted_10 = { class: "topic-card-breakdown-count" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle negative" }, "⬤", -1))
const _hoisted_12 = { class: "topic-card-breakdown-count-container" }
const _hoisted_13 = { class: "topic-card-breakdown-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(((_ctx.topicResponseCount / _ctx.totalResponseCount) * 100).toFixed(
                        0
                    )) + "% of all responses (" + _toDisplayString(_ctx.totalResponseCount) + ") ", 1),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.getBreakdownLineBg),
        class: "topic-card-breakdown-line"
      }, null, 4),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.positiveLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.positiveCount), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.positivePercent) + "%", 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.neutralLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.neutralCount), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.neutralPercent) + "%", 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.negativeLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.negativeCount), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.negativePercent) + "%", 1)
          ])
        ])
      ])
    ])
  ]))
}